import { appUrl } from "@/constants";

function getApiOrigin(): string | null {
  if (!appUrl) {
    return null;
  }

  try {
    return new URL(appUrl).origin;
  } catch {
    return null;
  }
}

export function resolveMediaUrl(url?: string | null): string | null {
  if (!url?.trim()) {
    return null;
  }

  const trimmed = url.trim();

  if (trimmed.startsWith("/")) {
    const origin = getApiOrigin();
    return origin ? `${origin}${trimmed}` : trimmed;
  }

  if (
    trimmed.startsWith("http://localhost") ||
    trimmed.startsWith("http://127.0.0.1")
  ) {
    const origin = getApiOrigin();
    if (!origin) {
      return trimmed;
    }

    try {
      const local = new URL(trimmed);
      return `${origin}${local.pathname}${local.search}`;
    } catch {
      return trimmed;
    }
  }

  return trimmed;
}

export function getRemoteImageSource(
  url?: string | null,
): { uri: string; headers?: Record<string, string> } | null {
  const resolved = resolveMediaUrl(url);
  if (!resolved) {
    return null;
  }

  const headers: Record<string, string> = {};

  if (resolved.includes("ngrok-free.app") || resolved.includes("ngrok.io")) {
    headers["ngrok-skip-browser-warning"] = "true";
  }

  return Object.keys(headers).length > 0
    ? { uri: resolved, headers }
    : { uri: resolved };
}
